function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "C57BB382-56CE-418A-9B5D-638725A5F29A");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Desktop-png",
  transform: "translate(-1195.000000, -63.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "icon-instagram",
  transform: "translate(1195.000000, 63.000000)"
}, React.createElement("path", {
  d: "M18.5375901,9.26879506 C18.5375901,14.3878752 14.3878752,18.5375901 9.26879506,18.5375901 C4.14971489,18.5375901 0,14.3878752 0,9.26879506 C0,4.14971489 4.14971489,0 9.26879506,0 C14.3878752,0 18.5375901,4.14971489 18.5375901,9.26879506 Z",
  id: "Path",
  fill: "#C4C4C4"
}), React.createElement("g", {
  id: "Group",
  transform: "translate(3.389938, 3.389938)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Group-2"
}, React.createElement("path", {
  d: "M8.348642,11.7916452 L3.44300321,11.7916452 C1.54447862,11.7916452 2.66453526e-14,10.2471666 2.66453526e-14,8.348642 L2.66453526e-14,3.44300321 C2.66453526e-14,1.54447862 1.54447862,0 3.44300321,0 L8.348642,0 C10.2471666,0 11.7916452,1.54447862 11.7916452,3.44300321 L11.7916452,8.348642 C11.7916452,10.2471666 10.2471666,11.7916452 8.348642,11.7916452 L8.348642,11.7916452 Z M3.44300321,0.999291967 C2.09552045,0.999291967 0.999291967,2.09552045 0.999291967,3.44300321 L0.999291967,8.348642 C0.999291967,9.69612476 2.09552045,10.7923532 3.44300321,10.7923532 L8.348642,10.7923532 C9.69612476,10.7923532 10.7923532,9.69612476 10.7923532,8.348642 L10.7923532,3.44300321 C10.7923532,2.09552045 9.69612476,0.999291967 8.348642,0.999291967 L3.44300321,0.999291967 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M5.89582261,9.0935569 C4.13261876,9.0935569 2.69808831,7.65902645 2.69808831,5.89582261 C2.69808831,4.13261876 4.13261876,2.69808831 5.89582261,2.69808831 C7.65902645,2.69808831 9.0935569,4.13261876 9.0935569,5.89582261 C9.0935569,7.65902645 7.65902645,9.0935569 5.89582261,9.0935569 Z M5.89582261,3.69738028 C4.68353052,3.69738028 3.69738028,4.68353052 3.69738028,5.89582261 C3.69738028,7.10811469 4.68353052,8.09426493 5.89582261,8.09426493 C7.10811469,8.09426493 8.09426493,7.10811469 8.09426493,5.89582261 C8.09426493,4.68353052 7.10811469,3.69738028 5.89582261,3.69738028 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M9.55429815,2.69470531 C9.55429815,2.94726073 9.34949536,3.15206352 9.0969399,3.15206352 C8.84438448,3.15206352 8.63958169,2.94726073 8.63958169,2.69470531 C8.63958169,2.44214985 8.84438448,2.23734706 9.0969399,2.23734706 C9.34949536,2.23734706 9.55429815,2.44214985 9.55429815,2.69470531 L9.55429815,2.69470531 Z",
  id: "Path"
}))))));

var SvgIconInstagram = function SvgIconInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-instagram.978d0f74.svg";
export { ForwardRef as ReactComponent };